import React from "react";
import { LINK_FIELDS, LIST_FIELDS, LONG_FIELDS, formatValue, isEmpty, itemLabel, listDiff } from "./proposalFormat";

// One field's change, old value to new: shared by the data-quality proposals and the host edits
// of live events. Lists show as chips that are kept, added or removed.

export function Value({ field, value, tone }) {
  if (isEmpty(value)) return <span className={`dq-value dq-value--${tone} dq-value--empty`}>leer</span>;
  const text = formatValue(field, value);
  if (LINK_FIELDS.has(field)) {
    return (
      <a className={`dq-value dq-value--${tone} dq-value--link`} href={String(value)} target="_blank" rel="noreferrer" title={String(value)}>
        {text}
      </a>
    );
  }
  return <span className={`dq-value dq-value--${tone}${LONG_FIELDS.has(field) ? " dq-value--long" : ""}`}>{text}</span>;
}

export function Change({ p }) {
  if (LIST_FIELDS.has(p.field)) {
    const entries = listDiff(p.field, p.oldValue, p.newValue);
    return (
      <div className="dq-chips" aria-label="Änderung der Liste">
        {entries.map(({ item, change }, i) => (
          <span key={i} className={`dq-chip dq-chip--${change}`} title={{ added: "neu", removed: "fällt weg", changed: "geändert", kept: "bleibt" }[change]}>
            {change === "added" && <span aria-hidden="true">+ </span>}
            {change === "removed" && <span aria-hidden="true">− </span>}
            {itemLabel(p.field, item)}
          </span>
        ))}
      </div>
    );
  }
  const long = LONG_FIELDS.has(p.field) && (String(p.oldValue ?? "").length > 40 || String(p.newValue ?? "").length > 40);
  return (
    <div className={`dq-change${long ? " dq-change--stacked" : ""}`}>
      <Value field={p.field} value={p.oldValue} tone="old" />
      <svg className="dq-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="wird zu">
        <path d={long ? "M12 5v14M5 12l7 7 7-7" : "M5 12h14M13 5l7 7-7 7"} />
      </svg>
      <Value field={p.field} value={p.newValue} tone="new" />
    </div>
  );
}
